const PesquisarTributacaoController = ControllerBase.extend({
    name: "PesquisarTributacaoController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descrição', prop: 'DescricaoProduto' }
        ],
        getData: function () {
            var modelAux = this.model.toJSON();

            if (modelAux.IdentificadorOrcamento) {
                modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
            }

            return modelAux;
        },
    }),

    ajax: function () {
        return {
            url: "/Produto/_TributacaoProduto",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                CodigoProduto: this.orcamento ? this.model.get("CodigoProduto") : this.model.get("Codigo"),
                IdentificadorOrcamento: this.orcamento ? this.orcamento.get("IdentificadorOrcamento") : ""
            })
        };
    },

    // O selector pesquisar-tributacao-produto-region deve ser especificado no novo html, neste caso _TributacaoProduto.cshtml
    renderizado: function () {
        this.tributacaoProdutoView = this.showView({
            region: {
                name: "tributacaoProdutoViewRegion",
                selector: "#pesquisar-tributacao-produto-region"
            },
            view: {
                type: TributacaoProdutoView,
                args: {
                    model: new Tributacao(this.tributacaoProduto)
                }
            }
        });
    }

})

window.PesquisarTributacaoController = PesquisarTributacaoController

export {
    PesquisarTributacaoController
}